// eslint-disable-next-line no-restricted-imports
import { partial } from "filesize";

// We represent file sizes and quota in base-10 for consistency across the IDEAS platform
export const filesize = partial({
  base: 10,
  standard: "jedec",
});
